module.exports = __FOREMAN_VENDOR__PROP_TYPES__;